/** 批量 AI 审查的视觉层常量（标签色）。中文标签在 types/aiReviewBatch.ts。 */

import type {
  AiReviewBatchItemStatus,
  AiReviewBatchStatus,
} from "../../types/aiReviewBatch";

export const BATCH_STATUS_TAG_COLOR: Record<AiReviewBatchStatus, string> = {
  pending: "default",
  running: "processing",
  completed: "success",
  partial_failed: "warning",
  failed: "error",
};

export const BATCH_ITEM_STATUS_TAG_COLOR: Record<AiReviewBatchItemStatus, string> = {
  pending: "default",
  running: "processing",
  succeeded: "success",
  failed: "error",
  skipped: "default",
};
